var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRescheduled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7.00006,
    r: 7,
    fill: "#EAEDF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.03125 4.03131V9.96881H9.96875V4.03131H4.03125ZM3.09375 3.87506C3.09375 3.44359 3.44353 3.09381 3.875 3.09381H10.125C10.5565 3.09381 10.9062 3.44359 10.9062 3.87506V10.1251C10.9062 10.5565 10.5565 10.9063 10.125 10.9063H3.875C3.44353 10.9063 3.09375 10.5565 3.09375 10.1251V3.87506Z",
    fill: "#525459"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.875 2.31256C9.13388 2.31256 9.34375 2.52243 9.34375 2.78131V3.56256C9.34375 3.82144 9.13388 4.03131 8.875 4.03131C8.61612 4.03131 8.40625 3.82144 8.40625 3.56256V2.78131C8.40625 2.52243 8.61612 2.31256 8.875 2.31256Z",
    fill: "#525459"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.125 2.31256C5.38388 2.31256 5.59375 2.52243 5.59375 2.78131V3.56256C5.59375 3.82144 5.38388 4.03131 5.125 4.03131C4.86612 4.03131 4.65625 3.82144 4.65625 3.56256V2.78131C4.65625 2.52243 4.86612 2.31256 5.125 2.31256Z",
    fill: "#525459"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.09375 5.43756C3.09375 5.17868 3.30362 4.96881 3.5625 4.96881H10.4375C10.6964 4.96881 10.9062 5.17868 10.9062 5.43756C10.9062 5.69644 10.6964 5.90631 10.4375 5.90631H3.5625C3.30362 5.90631 3.09375 5.69644 3.09375 5.43756Z",
    fill: "#525459"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRescheduled);
export default __webpack_public_path__ + "static/media/Rescheduled.8f0c0772.svg";
export { ForwardRef as ReactComponent };